import Module from '../../Module';
import mock from './mock';
import { Node } from '../';
import config from 'config';
import services from 'core/services';

class BasicService extends Module {
  get baseURL() {
    return '/api/v1/nodes'
  }

  initMock(handler) {
    mock(this.handler)
  }

  /**
   * parse array of nodes
   * @param {Array} nodes 
   */
  parseNodes(nodes) {
    if (!nodes) return []

    return nodes.map(node => {
      return Node.parseNode(node);
    });
  };

  /**
   * get all sliders
   */
  getSliders(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/slider`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.nodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          });
    });
  };

  getPromotion(number, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/promotion${number}`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.nodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          });
    });
  };

  getCategory(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}/categories`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.nodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          });
    });
  };

  /**
   * get products
   */
  getProducts(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}/main_categories/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  /**
   * get most popular products
   */
  newProducts(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}/main_categories/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  /**
   * get most off products
   */
  mostPopular(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}/main_categories/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  /**
   * get best sellers products
   */
  bestSellers(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}/main_categories/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  /**
   * get most discounts of products
   */
  discounts(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}/main_categories/products`, {
          params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                nodes: this.parseNodes(data.productNodes)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }
}

export default new BasicService()
